// 当前企业主页状态 myEnterpriseHome
export const state = () => {
  return {
    // 有数据可用的模块keys; string[]
    availableModuleKeys: [],
  }
}

export const mutations = {
  addAvailableModuleKey(state, moduleKey) {
    if (!state.availableModuleKeys.includes(moduleKey)) {
      state.availableModuleKeys = [...state.availableModuleKeys, moduleKey]
    }
  },
  resetAvailableModuleKeys(state) {
    state.availableModuleKeys = []
  },
}
